import { render, staticRenderFns } from "./TabClientiResa.vue?vue&type=template&id=3f10ceee&"
import script from "./TabClientiResa.vue?vue&type=script&lang=js&"
export * from "./TabClientiResa.vue?vue&type=script&lang=js&"
import style0 from "./TabClientiResa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports